<template>
  <div class="min-h-screen bg-gray-50 p-6">
    <div class="max-w-7xl mx-auto">
      <!-- Search and Filter Section -->
      <div class="flex gap-4 mb-6">
        <!-- Filters Dropdown -->
        <div class="relative">
          <button
            @click="showFilters = !showFilters"
            class="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
            </svg>
            <span class="font-medium text-gray-700">Filters</span>
            <svg class="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
        </div>

        <!-- Search Bar -->
        <div class="flex flex-1 max-w-md">
          <input
            type="text"
            v-model="searchQuery"
            placeholder="Search"
            class="flex-1 px-4 py-2 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none"
          />
          <button class="px-6 py-2 bg-orange-500 text-white rounded-r-lg hover:bg-orange-600 transition-colors">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
            </svg>
          </button>
        </div>
      </div>

      <!-- Statistics Cards -->
      <div class="grid grid-cols-3 gap-6 mb-6">
        <div v-for="stat in currentStats" :key="stat.label" :class="stat.bgClass + ' rounded-lg shadow p-6'">
          <p class="text-gray-600 text-sm mb-2">{{ stat.label }}</p>
          <p class="text-4xl font-bold text-gray-800">{{ stat.value }}</p>
        </div>
      </div>

      <!-- Tabs -->
      <div class="flex gap-8 border-b border-gray-200 mb-6">
        <button
          @click="activeTab = 'pending'"
          :class="[
            'pb-3 font-semibold transition-colors relative',
            activeTab === 'pending'
              ? 'text-blue-900 border-b-2 border-blue-900'
              : 'text-gray-500 hover:text-gray-700'
          ]"
        >
          Appeals
        </button>
        <!-- <button
          @click="activeTab = 'closed'"
          :class="[
            'pb-3 font-semibold transition-colors relative',
            activeTab === 'closed'
              ? 'text-blue-900 border-b-2 border-blue-900'
              : 'text-gray-500 hover:text-gray-700'
          ]"
        >
          Donations
        </button> -->
      </div>

      <!-- Tab Content -->
      <AppealsTab v-if="activeTab === 'pending'" :search-query="searchQuery" @update-stats="updateAppealsStats" />
      <DonationsTab v-else :search-query="searchQuery" />
    </div>
  </div>
</template>

<script>
import AppealsTab from '@/views/tabs/AppealsTab.vue';
import DonationsTab from '@/views/tabs/DonationsTab.vue';

export default {
  name: 'AppealsDonations',
  components: {
    AppealsTab,
    DonationsTab
  },
  data() {
    return {
      dropdownOpen: false,
      showFilters: false,
      searchQuery: '',
      activeTab: 'pending',
      appealsStats: {
        allAppeals: 50,
        pendingAppeals: 40,
        collectedAppeals: 5
      },
      donationsStats: {
        totalDonations: 120,
        inHospitalDonations: 75,
        mobileVanDonations: 45
      }
    };
  },
  computed: {
    currentStats() {
      if (this.activeTab === 'pending') {
        return [
          { label: 'Total Appeals', value: this.appealsStats.allAppeals, bgClass: 'bg-white' },
          { label: 'Pending Collection', value: this.appealsStats.pendingAppeals, bgClass: 'bg-red-50' },
          { label: 'Collected Appeals', value: this.appealsStats.collectedAppeals, bgClass: 'bg-green-50' }
        ];
      } else {
        return [
          { label: 'Total Donations', value: this.donationsStats.totalDonations, bgClass: 'bg-white' },
          { label: 'In-Hospital Donations', value: this.donationsStats.inHospitalDonations, bgClass: 'bg-blue-50' },
          { label: 'Mobile Van Donations', value: this.donationsStats.mobileVanDonations, bgClass: 'bg-green-50' }
        ];
      }
    }
  },
  methods: {
    updateAppealsStats(stats) {
      this.appealsStats = stats;
    },
    redirectProfilePage() {
      // Navigate to e-learning dashboard as profile placeholder
      this.$router.push('/e-learning');
    },
    logout() {
      this.$store.dispatch('logout', { system: 'appeals' });
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
/* Additional custom styles if needed */
</style>